// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "608690d2",
    "hash": "608690d2",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "608690d2",
    "semverString": null,
    "version": "1.0.0"
};
/* tslint:enable */
